import { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api, { fmtErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { lastSegment } from "@/components/FolderBreadcrumb";
import { useTranslation } from "react-i18next";

export function RenameFolderDialog({ folder, scope, ownerId, cur, queryKey, onNavigate, onClose }) {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const [name, setName] = useState("");

  useEffect(() => {
    if (folder) setName(lastSegment(folder));
  }, [folder]);

  const renameFolderMut = useMutation({
    mutationFn: async () => (await api.post("/drive/folders/rename", { scope, owner_id: ownerId || undefined, path: folder, new_name: name })).data,
    onSuccess: (d) => {
      toast.success(t("common.renamedToast"));
      if (cur === folder || cur.startsWith(folder + "/")) onNavigate(d.name + cur.slice(folder.length));
      onClose();
      qc.invalidateQueries({ queryKey });
    },
    onError: (e) => toast.error(fmtErr(e)),
  });

  return (
    <Dialog open={!!folder} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="drive-rename-folder-dialog">
        <DialogHeader><DialogTitle>{t("common.renameFolder")} — {folder}</DialogTitle></DialogHeader>
        <div className="space-y-1.5">
          <Label>{t("common.newName")}</Label>
          <Input value={name} onChange={(e) => setName(e.target.value)} data-testid="drive-rename-folder-input" />
        </div>
        <DialogFooter>
          <Button onClick={() => renameFolderMut.mutate()} disabled={!name.trim() || renameFolderMut.isPending} data-testid="drive-rename-folder-submit">{t("common.save")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
